// extracted by mini-css-extract-plugin
export var active = "breadcrumb-module--active--55f48";
export var backgroundColor = "#141821";
export var borderRadius = ".15rem";
export var breadcrumb = "breadcrumb-module--breadcrumb--b5a6a";
export var breadcrumbItem = "breadcrumb-module--breadcrumb-item--76859";
export var maxModalWidth = "48em";
export var modalBackgroundColor = "rgba(20,24,33,.75)";